import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import s from './css/QuestionScreen.css';
import gs from '../global.css';
class ThankScreen extends Component {
    componentDidMount() {
        document.title = 'Sticknet | Thank You';
        window.scrollTo(0, 0);
    }
    render() {
        const isDesktop = window.innerWidth > window.innerHeight;
        return (React.createElement("div", { className: gs.main, style: {
                height: isDesktop ? '70vh' : '60vh',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement("div", { className: gs.screenContainer },
                React.createElement("h1", { className: s.headerTitle }, "Thank You!"),
                React.createElement("p", { className: s.thank }, "Thank you for contacting us. We will review your query and get back to you as soon as possible."),
                React.createElement("button", { type: 'submit', onClick: () => this.props.history.push('/') },
                    React.createElement("p", { className: s.send }, "Done")))));
    }
}
export default withRouter(ThankScreen);
